module.exports = __webpack_public_path__ + "img/logo.4a5a0bf0.png";